import { createApi } from '@reduxjs/toolkit/query/react';

import { HTTP_METHOD } from '../constants';
import * as endpoints from '../endpoints';
import {
  TransformedErrorResponseWithNotification,
  getBaseQuery,
} from '../generic';

export interface IPostSupportContactRequestBody {
  name: string;
  email: string;
  title: string;
  message: string;
}

export const supportApi = createApi({
  reducerPath: 'supportApi',
  baseQuery: getBaseQuery(endpoints.Support.ROOT),
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    postSupportContactApi: builder.mutation<
      { id: string },
      { body: IPostSupportContactRequestBody }
    >({
      query({ body }) {
        return {
          url: endpoints.Support.CONTACT,
          method: HTTP_METHOD.POST,
          body,
        };
      },
      ...TransformedErrorResponseWithNotification(),
    }),
  }),
});

export const { usePostSupportContactApiMutation: usePostSupportContact } =
  supportApi;
